export const name = 're-video-frame-range-slider'

import CalcMixin from './calc'
import ElementsMixin from './elements'
import EventsMixin from './events'
import PlayerMixin from './player'
import DraggerMixin from './dragger'
import {min, max, floor, ceil, round, seconds2Hours, fv} from 'utils/vue/lib/formatters'

export {min, max, floor, ceil, round, seconds2Hours, fv}

export const CONTEXT_ELEMENT_SELECTOR = '.re-video-frame-selector'
export const FRAMES_ELEMENT_SELECTOR = '.re-video-frames'
export const START_ELEMENT_PARENT_SELECTOR = '.re-video-frame-start'
export const START_ELEMENT_SELECTOR = '.re-video-frame-start .re-video-frame-range-drag-handler'
export const END_ELEMENT_PARENT_SELECTOR = '.re-video-frame-end'
export const END_ELEMENT_SELECTOR = '.re-video-frame-end .re-video-frame-range-drag-handler'
export const START_TEXT_SELECTOR = '.re-frame-time-display .re-frame-start-time'
export const END_TEXT_SELECTOR = '.re-frame-time-display .re-frame-end-time'
export const SELECTED_ELEMENT_SELECTOR = '.re-video-frames-selected'
export const SEEK_LINE_SELECTOR = '.re-video-current-time-line'

export const elements = {
    frames: FRAMES_ELEMENT_SELECTOR,
    context: CONTEXT_ELEMENT_SELECTOR,
    startParent: START_ELEMENT_PARENT_SELECTOR,
    start: START_ELEMENT_SELECTOR,
    endParent: END_ELEMENT_PARENT_SELECTOR,
    end: END_ELEMENT_SELECTOR,
    selected: SELECTED_ELEMENT_SELECTOR,
    startText: START_TEXT_SELECTOR,
    endText: END_TEXT_SELECTOR,
    seek: SEEK_LINE_SELECTOR,
}

export const calc = {min, max, floor, ceil, round, fv}
export const format = {seconds2Hours}

export const components = {}

export const mixins = [CalcMixin, ElementsMixin, EventsMixin, DraggerMixin, PlayerMixin]

export const props = {
    value: {
        default: null,
    },
    data: {
        type: Object,
        required: true,
    },
    options: {
        type: Object,
        default: () => ({})
    },
    player: {},
}

export const data = {

}

export default {
    name,
    components,
    mixins,
    props,
    data,
    elements,
    calc,
    format
}
